import {Injectable} from '@angular/core';
import { ReportConfigurationMetaData, ReportConfigurationResult } from '../models/reports/reports-query-result';
import {GraphQLClientService} from './graphql-client.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private reportsQueryMapper: any = {};

  constructor(private graphQLClient: GraphQLClientService) {
  }

  async getReport(reportType: string, ...params: any): Promise<any> {
    let report;
    switch (reportType) {
      case 'whoIsBeenInTodayReport':
        report = await this.whoIsBeenTodayReport(...params);
        break;
      case 'attendanceReport':
        report = await this.attendanceReport(params);
        break;
    }
    return report;
  }

  private async attendanceReport(params): Promise<any> {
    const query = `query{
      attendanceReport(savedReportId:${params[0]?.reportType ? params[0].reportType : -1}, month: ${params[0]?.month ? params[0]?.month : 1} )
          {
            results{ data {exit entry durationInHours date day comments department}
              summary {absenceDays autoArrival autoLeave averageHoursInSeconds hours earlyLeave lateDays workingDays}
              employeeId
              employeeName
              }
               totalCount
          }
     }`;

    const response = (await this.graphQLClient.requestAsync<any>(query));
    return response?.data.attendanceReport;
  }

  private async whoIsBeenTodayReport(...params): Promise<any> {
    const query: string = `query{
      whosBeenInTodayReport
      {
        results
        {
          name department location date imageBase64 userTypeId
        }
        totalCount
      }
    }`;
    const response = (await this.graphQLClient.requestAsync<any>(query));
    return response?.data.whosBeenInTodayReport;
  }

  public async getConfiguration(): Promise<ReportConfigurationMetaData> {

    const query = `
      query{
        configurations{
          reportConfigurations {
            attendanceReportSubTypes {id description} attendanceReportTypes{id description}  workDaysTypes{id description}  departments {id description} readers {id description} attendanceSavedReports{id description}
          }
        }
      }
    `;
    return (await this.graphQLClient.requestAsync<ReportConfigurationResult>(query))?.data.configurations.reportConfigurations;
  }
}
